import { Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy, HostBinding } from '@angular/core';
import { FormBaseComponent } from '../../models/form-base-component';
import { FormLabelField } from './form-label.model';
import { FormFieldService } from '../../services/form-field.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'gio-form-label',
  templateUrl: './form-label.component.html',
  styleUrls: ['./form-label.component.scss'],
  host: {
    '[class]': 'classNames'
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormLabelComponent extends FormBaseComponent<FormLabelField> {
  @HostBinding('style')
  get myStyle() { return this.getHostStyles(); }

  constructor(
    private cd: ChangeDetectorRef,
    public _service: FormFieldService,
    sanitizer: DomSanitizer
  ) { super(cd, _service, sanitizer); }


  onComponentInit() {
    if (this.field.hostStyle) {
      setTimeout(() => {
        this.cd.detectChanges();
      }, 100);
    }

    this.subscribe = this.service.detectChanges$.subscribe(() => {
      this.cd.detectChanges();
    })
  }
  onComponentDestroy() { }


}
